import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type SetDpoPayload = {
  location_id: number;
  user_id: number;
};

export const useSetDpoMutation = () =>
  useTypedMutation({
    mutationFn: async ({ user_id }: SetDpoPayload) => (await ApiInstance.post(`/agreements/data_officer/set`, { user_id }, ENV.dealerBaseURL)).data,
    onSuccess: ({ user_id, location_id }) => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      const { users } = prevUsers;
      const newDpoIdx = users.findIndex(user => user.id === user_id);
      if (newDpoIdx === -1) return;

      const currentDpoIdx = users.findIndex(user => user.dpo && user.dealer_location_id === location_id);
      const demotedDpoUsers = currentDpoIdx === -1 ? users : users.with(currentDpoIdx, { ...users[currentDpoIdx], dpo: false });
      const updatedDpoUsers = demotedDpoUsers.with(newDpoIdx, { ...users[newDpoIdx], dpo: true });

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, { ...prevUsers, users: updatedDpoUsers });
    }
  });
